<template>
	<BaseButton
		:classes="computedClass"
		:label="label"
		:size="size"
		:disabled="isDisabled"
		@click="$emit('click')"
	/>
</template>
<script>
import BaseButton from '@/components/shared/Button/BaseButton/BaseButton.vue';

export default {
	name: 'ButtonTertiary',
	components: {
		BaseButton,
	},
	props: {
		label: {
			type: String,
			required: true,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: 'md',
		},
		outline: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		computedClass() {
			return [this.outline ? 'button__tertiary--outline' : 'button__tertiary'];
		},
	},
};
</script>
<style lang="scss" scoped>
@import './ButtonTertiary.scss';
</style>
